/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import toastr from '@/lib/notifications';
import $ from 'jquery';
import _ from 'underscore';
import axios from 'axios'
import store from '../state/store';

const tutorResultSortFunction = function(a, b) {
  if ((a.job_candidate.accepted ===true) && (b.job_candidate.accepted !==true)) {
    return -1;
  }

  if ((a.job_candidate.accepted !==true) && (b.job_candidate.accepted ===true)) {
    return 1;
  }

  if ((a.job_candidate.proposed ===true) && (b.job_candidate.proposed !==true)) {
    return -1;
  }

  if ((a.job_candidate.proposed !==true) && (b.job_candidate.proposed ===true)) {
    return 1;
  }

  if ((a.job_candidate.shortlisted ===true) && (b.job_candidate.shortlisted !==true)) {
    return -1;
  }

  if ((a.job_candidate.shortlisted !==true) && (b.job_candidate.shortlisted ===true)) {
    return 1;
  }

  if ((a.job_candidate.applied ===true) && (b.job_candidate.applied !==true)) {
    return -1;
  }

  if ((a.job_candidate.applied !==true) && (b.job_candidate.applied ===true)) {
    return 1;
  }

  if ((a.job_candidate.declined ===true) && (b.job_candidate.declined !==true)) {
    return 1;
  }

  if ((a.job_candidate.declined !==true) && (b.job_candidate.declined ===true)) {
    return -1;
  }

  if ((a.job_candidate.rejected ===true) && (b.job_candidate.rejected !==true)) {
    return 1;
  }

  if ((a.job_candidate.rejected !==true) && (b.job_candidate.rejected ===true)) {
    return -1;
  }

  if ((a.job_candidate.applied_at ===true) && (b.job_candidate.applied_at !==true)) {
    return -1;
  }

  if ((a.job_candidate.applied_at !==true) && (b.job_candidate.applied_at ===true)) {
    return 1;
  }

  return 0;
};

store.on('tutoring_job:tutor_results:index', function(tutoring_job_id, params) {
  if (params == null) {
    params = {}
  }

  store.get().ui.tutoring_job.set({loading_tutors: true})
  const filter = params.filter || store.get().ui.tutoring_job.tutor_results_filter

  let url = `/api/sales/tutoring_jobs/${tutoring_job_id}/tutors?filter=${filter}`
  if (filter === 'searched' || filter === '') {
    const experience_level = store.get().ui.tutoring_job.tutor_experience_level
    const active_within = store.get().ui.tutoring_job.tutor_active_within
    const onboarded_after = store.get().ui.tutoring_job.onboarded_after
    const search_bio = store.get().ui.tutoring_job.tutor_search_bio
    url += `&experience_level=${experience_level}&active_within=${active_within}&onboarded_after=${onboarded_after}&search_bio=${encodeURIComponent(search_bio || '')}`
  }

  axios.get(url)
  .then(function(response) {
    const data = response.data
    store.get().ui.tutoring_job.set({loading_tutors: false})
    const tutor_results = data.items
    tutor_results.sort(tutorResultSortFunction)
    store.get().set({tutor_results})
  })
  .catch(function(error) {
    handleError(error)
  })
});

store.on('tutoring_job:tutor_results:show', function(tutoring_job_id, tutor_id) {
  axios.get(`/api/sales/tutoring_jobs/${tutoring_job_id}/tutors/${tutor_id}`)
  .then(function(response) {
    const data = response.data

    const tutor_result = _.first(
      _.select(store.get().tutor_results, function(tutor_result) {
        return tutor_result.tutor.id === tutor_id
      })
    )

    if (tutor_result) {
      tutor_result.set(data)
    }
  })
  .catch(function(error) {
    handleError(error)
  })
});

store.on('lesson_plan:tutor_results:index', function(lesson_plan_id, params) {
  if (params == null) {
    params = {}
  }

  store.get().ui.tutoring_job.set({loading_tutors: true})
  const filter = params.filter || store.get().ui.tutoring_job.tutor_results_filter

  let url = `/api/sales/lesson_plans/${lesson_plan_id}/tutors?filter=${filter}`
  if (filter === 'searched' || filter === '') {
    const experience_level = store.get().ui.tutoring_job.tutor_experience_level
    const active_within = store.get().ui.tutoring_job.tutor_active_within
    const onboarded_after = store.get().ui.tutoring_job.onboarded_after
    const search_bio = store.get().ui.tutoring_job.tutor_search_bio
    url += `&experience_level=${experience_level}&active_within=${active_within}&onboarded_after=${onboarded_after}&search_bio=${encodeURIComponent(search_bio || '')}`
  }

  axios.get(url)
  .then(function(response) { 
    const data = response.data
    store.get().ui.tutoring_job.set({loading_tutors: false})
    const tutor_results = data.items
    tutor_results.sort(tutorResultSortFunction)
    store.get().set({tutor_results})
  })
  .catch(function(error) {
    handleError(error)
  })
});

store.on('tutoring_job:tutor_results:create', function(params) {
  if (params == null) { params = {}; }
  return $.ajax({
    url: `/api/sales/tutoring_jobs/${params.tutoring_job_id}/job_candidates`,
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(params),
    success: (data) => {
      return store.emit('tutoring_job:tutor_results:index', params.tutoring_job_id);
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

store.on('tutoring_job:tutor_results:update', function(params) {
  if (params == null) { params = {}; }
  return $.ajax({
    url: `/api/sales/tutoring_jobs/${params.tutoring_job_id}/job_candidates`,
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(params),
    success: (data) => {
      const { tutor_results } = store.get();
      const tutor_result = _.first(_.select(tutor_results, tutor_result => tutor_result.tutor.id ===params.tutor_id));
      return tutor_result.set({job_candidate: data});
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

store.on('tutoring_job:tutor_results:accept', function(params) {
  if (params == null) { params = {}; }
  return $.ajax({
    url: `/api/sales/tutoring_jobs/${params.tutoring_job_id}/job_candidates/accept`,
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(params),
    success: (data) => {
      const { tutor_results } = store.get();
      const tutor_result = _.first(_.select(tutor_results, tutor_result => tutor_result.tutor.id ===params.tutor_id));
      tutor_result.set({job_candidate: data});
      store.emit('tutoring_jobs:show', params.tutoring_job_id);
      return toastr.success('Tutor accepted!');
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

store.on('tutoring_job:tutor_results:reject', function(params) {
  if (params == null) { params = {}; }
  return $.ajax({
    url: `/api/sales/tutoring_jobs/${params.tutoring_job_id}/job_candidates/reject`,
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(params),
    success: (data) => {
      const { tutor_results } = store.get();
      const tutor_result = _.first(_.select(tutor_results, tutor_result => tutor_result.tutor.id ===params.tutor_id));
      tutor_result.set({job_candidate: data});
      store.emit('tutoring_jobs:show', params.tutoring_job_id);
      return toastr.success('Tutor rejected!');
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

store.on('tutoring_job:tutor_results:notify', function(params) {
  if (params == null) { params = {}; }
  return $.ajax({
    url: `/api/sales/tutoring_jobs/${params.tutoring_job_id}/job_alerts`,
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(params),
    success: (data) => {
      toastr.success('Tutor notified!');
      const { tutor_results } = store.get();
      const tutor_result = _.first(_.select(tutor_results, tutor_result => tutor_result.tutor.id ===params.tutor_id));
      return tutor_result.set({job_candidate: data.job_candidate});
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

store.on('tutoring_job:tutor_results:availability:update', function(params) {
  if (params == null) { params = {}; }
  return $.ajax({
    url: `/api/sales/tutoring_jobs/${params.tutoring_job_id}/job_candidates`,
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(params),
    success: (data) => {
      store.emit('tutoring_job:tutor_results:show', params.tutoring_job_id, params.tutor_id)
      return toastr.success('Availability saved!');
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

store.on('tutoring_job:tutor_results:reject_all_applied', function(params) {
  if (params == null) { params = {}; }
  return $.ajax({
    url: `/api/sales/tutoring_jobs/${params.tutoring_job_id}/job_candidates/reject_all_applied`,
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(params),
    success: (data) => {
      store.emit('tutoring_jobs:show', params.tutoring_job_id);
      return toastr.success('Applied tutors rejected!');
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

store.on('tutoring_job:tutor_results:reject_all_proposed', function(params) {
  if (params == null) { params = {}; }
  return $.ajax({
    url: `/api/sales/tutoring_jobs/${params.tutoring_job_id}/job_candidates/reject_all_proposed`,
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(params),
    success: (data) => {
      store.emit('tutoring_jobs:show', params.tutoring_job_id);
      return toastr.success('Proposed tutors rejected!');
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

store.on('tutoring_job:tutor_results:meeting_availability:update', function(params) {
  if (params == null) { params = {}; }
  return $.ajax({
    url: `/api/sales/tutors/${params.tutor_id}/meeting_availabilities`,
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(params),
    success: (data) => {
      store.emit('tutoring_job:tutor_results:show', params.tutoring_job_id, params.tutor_id)
      return toastr.success('Meeting availability saved!');
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}